<template>

    <button class="close" :class="classes">
        <i class="fas fa-times"></i>
    </button>

</template>

<style scoped lang="scss">

    .close {

        appearance: none;
        background: none;
        border: none;
        color: rgba(0,0,0,0.5);
        cursor: pointer;
        display: grid;
        font-size: 16px;
        height: 40px;
        line-height: 0;
        margin: 0;
        opacity: 0.8;
        padding: 0;
        place-items: center;
        position: absolute;
        right: 0;
        text-align: center;
        text-decoration: none;
        top: 0;
        transition: opacity .3s;
        user-select: none;
        width: 40px;
        z-index: 1;

        &:hover {
            opacity: 1 !important;
        }

        &.close-info {
            color: $color-primary;
        }
        &.close-danger {
            color: $color-danger;
        }
        &.close-warning {
            color: $color-warning;
        }
        &.close-success {
            color: $color-success;
        }

    }

</style>

<script>

export default {

    props: {
        type: {
            type: String,
        },
    },

    computed: {

        classes() {
            return {
                'close-info': this.type === 'info',
                'close-danger': this.type === 'danger',
                'alert-warning': this.type === 'warning',
                'alert-success': this.type === 'success',
            };
        },

    },

}

</script>